
import React from 'react';
import '../styles/OurkeyInd.css';

const OurkeyInd = () => {
  return (
    <div className='indus'>
      <h1 id='ourkey'>Our Key Industries</h1>
      <div id='indus-child'>
        <div id='ind-img1'>
          <font id="ind-font">Defence & Military</font>
        </div>
        <div id='ind-img2'>
          <font id="ind-font">Aerospace</font>
        </div>
        <div id='ind-img3'>
          <font id="ind-font">Power & Energy</font>
        </div>
        <div id='ind-img4'>
          <font id="ind-font">Transportation</font>
        </div>
        <div id='ind-img5'>
          <font id="ind-font">Medical</font>
        </div>
      </div>
    </div>
  )
}

export default OurkeyInd